module.exports = new __parcel__URL__("portfolio_portrait.9e068fab.png").toString();